var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteMembersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0C9.4017 0 0 9.4017 0 21C0 32.5983 9.4017 42 21 42C32.5983 42 42 32.5983 42 21C42 9.4017 32.5983 0 21 0ZM29.4 23.1H23.1V29.4C23.1 30.5592 22.1592 31.5 21 31.5C19.8408 31.5 18.9 30.5592 18.9 29.4V23.1H12.6C11.4408 23.1 10.5 22.1592 10.5 21C10.5 19.8408 11.4408 18.9 12.6 18.9H18.9V12.6C18.9 11.4408 19.8408 10.5 21 10.5C22.1592 10.5 23.1 11.4408 23.1 12.6V18.9H29.4C30.5592 18.9 31.5 19.8408 31.5 21C31.5 22.1592 30.5592 23.1 29.4 23.1Z",
    fill: "#F9B22D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteMembersIcon);
export default __webpack_public_path__ + "static/media/inviteMembersIcon.3a6b5d7cc1e7c50e5a388bd128fe887d.svg";
export { ForwardRef as ReactComponent };